import { render, staticRenderFns } from "./pos_db.vue?vue&type=template&id=208c7aee&scoped=true&"
import script from "./pos_db.vue?vue&type=script&lang=js&"
export * from "./pos_db.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c7aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208c7aee')) {
      api.createRecord('208c7aee', component.options)
    } else {
      api.reload('208c7aee', component.options)
    }
    module.hot.accept("./pos_db.vue?vue&type=template&id=208c7aee&scoped=true&", function () {
      api.rerender('208c7aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/db_parmas/pos_db.vue"
export default component.exports